import { Observable } from 'rxjs';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';
import { TipoPlanSaludModel } from '../../models/configuration/tipo-plan-salud.model';

export class GetTipoPlanSaludUseCase implements UseCase<void, TipoPlanSaludModel>{
	constructor(private configRepository: ConfigurationRepository) { }
	execute(): Observable<TipoPlanSaludModel> {
	  return this.configRepository.getTipoPlanSalud();
	}
}